<template>
  <Teleport to="body" v-if="$props.show">
    <div class="fixed inset-0 bg-black opacity-70 flex">
    </div>
    <div @click.prevent="closeModal" class="fixed inset-0 flex items-center justify-center">
      <!-- Модальное окно -->
      <div @click.stop class="bg-white rounded-lg shadow-xl w-full" :class="modalClass">
        <!-- Заголовок -->
        <div class="px-6 py-4">
          <h3 class="text-xl font-semibold text-gray-800">{{ $props.title }}</h3>
        </div>

        <!-- Тело модального окна с полями ввода -->
        <div class="p-6 space-y-4">
          <slot></slot>
        </div>

        <!-- Футер модального окна с кнопками -->
        <div class="px-6 py-4 flex justify-end space-x-3">
          <button v-if="showCancel" @click.prevent="closeModal" id="cancelButton" class="px-4 py-2 text-gray-600 hover:text-gray-800 font-medium rounded-md cursor-pointer">
            Отмена
          </button>
          <button v-if="showDone" @click.prevent="done" id="okButton" class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md cursor-pointer">
            {{ $props.doneButtonText }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'ModalWindow',
  props: {
    title: {
      type: String,
    },
    weight: {
      type: Number,
      default: null,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showDone: {
      type: Boolean,
      default: true,
    },
    doneButtonText: {
      type: String,
      default: 'OK'
    },
    show: {
      type: Boolean,
    }
  },
  computed: {
    modalClass: function () {
      return this.weight ? 'max-w-' + this.weight : 'max-w-md';
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    done() {
      this.$emit('done')
    }
  },
  mounted() {
    //this.load()
  }
}
</script>

<style scoped>

</style>